export default __webpack_public_path__ + "static/media/card-chip.e1bd4bba.svg";